import { ArrowUp, Robot } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { useThinkerDock } from "~/features/work/piles/pilesApi";
import { useWorkspaceDecisions } from "~/features/work/WorkspaceDecisions";
import { useConversationScope, useWorkspaceComposer } from "./conversationApi";

/** One composer shared with the conversation, always reachable from the console. */
export function WorkspaceThinkerComposer() {
  const { t } = useTranslation();
  const scope = useConversationScope();
  const decisions = useWorkspaceDecisions(true);
  const { drafts, setDraft, submit } = useWorkspaceComposer();
  const open = useThinkerDock((s) => s.open);
  return (
    <form
      className="order-last flex h-8 w-full min-w-0 items-center gap-1 rounded-md border border-input-border bg-bg px-1 focus-within:border-input-border-focus lg:order-none lg:w-auto lg:min-w-48 lg:max-w-lg lg:flex-1"
      onSubmit={(e) => {
        e.preventDefault();
        if (scope) {
          useThinkerDock.getState().show();
          submit(scope);
        }
      }}
    >
      <button
        type="button"
        aria-label={t("Open workspace thinker")}
        aria-expanded={open}
        aria-controls="workspace-thinker-panel"
        className="shrink-0 rounded p-1 text-accent hover:bg-hover-bg"
        onClick={() =>
          open ? useThinkerDock.getState().close() : useThinkerDock.getState().show()
        }
      >
        <Robot size={19} aria-hidden />
      </button>
      <button
        type="button"
        onClick={() => useThinkerDock.getState().showDecisions()}
        aria-label={t("Open workspace decisions")}
        className="shrink-0 rounded border border-divider bg-accent/10 px-2 py-1 text-caption font-semibold text-accent"
      >
        {t("Decisions")}
        {decisions.error ? " · !" : decisions.data ? ` · ${decisions.data.entries.length}` : ""}
      </button>
      <input
        aria-label={t("Tell the workspace thinker")}
        placeholder={t("Ask, discuss, or give an instruction…")}
        className="w-full min-w-0 bg-transparent text-small text-text outline-none"
        maxLength={2000}
        disabled={!scope}
        value={scope ? (drafts[scope] ?? "") : ""}
        onChange={(e) => scope && setDraft(scope, e.target.value)}
        onFocus={() => useThinkerDock.getState().show()}
      />
      <button
        type="submit"
        aria-label={t("Send to workspace thinker")}
        disabled={!scope || !drafts[scope]?.trim()}
        className="shrink-0 rounded bg-accent p-1 text-white disabled:opacity-30"
      >
        <ArrowUp size={16} aria-hidden />
      </button>
    </form>
  );
}
